import * as mockActions from './mockActions';
import * as productionActions from './productionActions';

import { MOCK_MODE } from '../constants';

let actions;

if (process.env.SERVERLESS || MOCK_MODE) {
  actions = mockActions;
} else {
  actions = productionActions;
}
export default actions;
